import Swiper from 'swiper';
import {Autoplay, EffectFade, Navigation, Pagination} from 'swiper/modules';

(() => {
    const swiperItems = document.querySelectorAll('.swiper[data-swiper]');
    if (swiperItems?.length === 0) return;
    swiperItems.forEach(swiperItem => {
        const dataSwiperAttributes = swiperItem.dataset.swiper;
        const dataSwiper = dataSwiperAttributes ? JSON.parse(dataSwiperAttributes) : null
        const dataSwiperOptions = {
            modules: [],
            allowTouchMove: dataSwiper?.allowTouchMove ?? true,
            autoHeight: dataSwiper?.autoHeight ?? false,
            autoplay: dataSwiper?.autoplay ?? {delay: 2000},
            breakpoints: dataSwiper?.breakpoints ?? null,
            centeredSlides: dataSwiper?.centeredSlides ?? false,
            effect: dataSwiper?.effect ?? 'slide',
            keyboard: dataSwiper?.keyboard ?? {},
            loop: dataSwiper?.loop ?? false,
            navigation: dataSwiper?.navigation ?? {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
            pagination: dataSwiper?.pagination ?? {el: ".swiper-pagination", clickable: true},
            slidesPerGroup: dataSwiper?.slidesPerGroup ?? 1,
            slidesPerView: dataSwiper?.slidesPerView ?? 1,
            spaceBetween: dataSwiper?.spaceBetween ?? 0,
            speed: dataSwiper?.speed ?? 1200,
            direction: dataSwiper?.direction ?? 'horizontal',
        };

        if (swiperItem.hasAttribute('data-swiper-autoplay')) dataSwiperOptions.modules.push(Autoplay);
        if (swiperItem.hasAttribute('data-swiper-navigation')) dataSwiperOptions.modules.push(Navigation);
        if (swiperItem.hasAttribute('data-swiper-pagination')) dataSwiperOptions.modules.push(Pagination);
        if (dataSwiper?.hasOwnProperty('effect') && dataSwiper.effect === 'fade') {
            dataSwiperOptions.modules.push(EffectFade);
            dataSwiperOptions.fadeEffect = {crossFade: true}
        }

        // Swiper init
        swiperItem.swiperInstance = new Swiper(swiperItem, dataSwiperOptions);
    });
})()